import { InsurancePlan, InsuranceService, MedicalGroup, Provider, DataResponse } from './types';

const insuranceServicesEndpoint = '/api/insurance-checker/v2/insurance-services';
const medicalGroupsEndpoint = '/api/insurance-checker/v2/medical-groups';
const insurancePlansEndpoint = '/api/insurance-checker/v2/plans';
const providersEndpoint = '/api/schedule/multi-meta?[]serviceArea=MPC&[]serviceArea=WEL&[]serviceArea=MTL';
const baseEndpoint = process.env.REACT_APP_API_URL;

const useFetchInsuranceServices = async ():Promise<InsuranceService[]> => {
    const response = await fetch(baseEndpoint + insuranceServicesEndpoint);
    const data = await response.json();
    return data.services;
};

const useFetchInsurancePlans = async ():Promise<InsurancePlan[]> => {
    const response = await fetch(baseEndpoint + insurancePlansEndpoint);
    const data = await response.json();
    return data.insurancePlans;
};

const useFetchMedicalGroups = async ():Promise<MedicalGroup[]> => {
    const response = await fetch(baseEndpoint + medicalGroupsEndpoint);
    const data = await response.json();
    return data.medicalGroups;
};

const useFetchProviders = async ():Promise<Provider[]> => {
    const response = await fetch(baseEndpoint + providersEndpoint);
    const data = await response.json();
    const providers = [ ...data.MPC.providers, ...data.WEL.providers, ...data.MTL.providers ];
    return providers.sort((a:Provider, b:Provider) => a.lastName.localeCompare(b.lastName));
};

export const useFetchData = async ():Promise<DataResponse> => {
    const services = await useFetchInsuranceServices();
    const plans = await useFetchInsurancePlans();
    const groups = await useFetchMedicalGroups();
    const providers = await useFetchProviders();

    const [ s, p, g, pcp ] = await Promise.all([ services, plans, groups, providers ]).then((data) => data);
    return {
        services: s,
        plans: p,
        groups: g,
        providers: pcp,
    };
};
